export const types = {
  SET_STEP: 'ACCOUNT/SET_STEP',
  SET_INFO: 'ACCOUNT/SET_INFO',
  SET_INFO_SUCCESS: 'ACCOUNT/SET_INFO_SUCCESS',
  SEND_OTP: 'ACCOUNT/SEND_OTP',
  VALIDATE_OTP: 'ACCOUNT/VALIDATE_OTP',
  PROGRESS_OTP: 'ACCOUNT/PROGRESS_OTP',
  PROGRESS_OTP_SUCCESS: 'ACCOUNT/PROGRESS_OTP_SUCCESS',
  PROGRESS_OBD: 'ACCOUNT/PROGRESS_OBD',
  PROGRESS_OBD_SUCCESS: 'ACCOUNT/PROGRESS_OBD_SUCCESS',
};

export const actions = {
  setStep: (data) => ({
    type: types.SET_STEP,
    payload: { data },
  }),
  setInfo: (data) => ({
    type: types.SET_INFO,
    payload: { data },
  }),
  setInfoSuccess: (data) => ({
    type: types.SET_INFO_SUCCESS,
    payload: { data },
  }),
  sendOtp: (data) => ({
    type: types.SEND_OTP,
    payload: { data },
  }),
  validateOtp: (data) => ({
    type: types.VALIDATE_OTP,
    payload: { data },
  }),
  progressOtp: (data) => ({
    type: types.PROGRESS_OTP,
    payload: { data },
  }),
  progressOtpSuccess: (data) => ({
    type: types.PROGRESS_OTP_SUCCESS,
    payload: { data },
  }),
  progressObd: (data) => ({
    type: types.PROGRESS_OBD,
    payload: { data },
  }),
  progressObdSuccess: (data) => ({
    type: types.PROGRESS_OBD_SUCCESS,
    payload: { data },
  }),
};

const initialState = {
  loadingForm: false,
  progressingOtp: false,
  progressingObd: false,
  step: null,
};

/* eslint-disable default-param-last */
function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SET_STEP: {
      const { data } = { ...action.payload };
      const { step } = { ...data };
      return {
        ...state,
        step,
      };
    }
    case types.SET_INFO: {
      return {
        ...state,
        loadingForm: true,
      };
    }
    case types.SET_INFO_SUCCESS: {
      return {
        ...state,
        loadingForm: false,
      };
    }
    case types.PROGRESS_OTP: {
      return {
        ...state,
        progressingOtp: true,
      };
    }
    case types.PROGRESS_OTP_SUCCESS: {
      return {
        ...state,
        progressingOtp: false,
      };
    }
    case types.PROGRESS_OBD: {
      return {
        ...state,
        progressingObd: true,
      };
    }
    case types.PROGRESS_OBD_SUCCESS: {
      return {
        ...state,
        progressingObd: false,
      };
    }
    default:
      return state;
  }
}

export default reducer;
